"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.058 16h1V0h-1v16Zm5.27-12.851h6.6V1.547h-6.6v1.602ZM3.58 11.926h10.302V4.149H3.58v7.777ZM16 1.547v-1H2.114v1h2.212v1.602H3.081a.5.5 0 0 0-.5.5v8.777a.5.5 0 0 0 .5.5h11.301a.5.5 0 0 0 .5-.5V3.649a.5.5 0 0 0-.5-.5h-1.454V1.547H16Zm-7.367 4.24L6.382 7.633v3.46h-1V7.159l3.223-2.641 3.444 2.574v4H8.97V9.03H7.52v-1h2.45v2.063h1.078v-2.5L8.633 5.787Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 23.954h1.123V0H0v23.954ZM7.603 4.978h10.414V2.15H7.603v2.827Zm-2.649 13.32h16.031V6.1H4.955v12.2ZM24 2.152V1.028H2.926v1.123h3.555v2.827H4.392a.562.562 0 0 0-.561.56V18.86c0 .31.251.561.561.561h17.155a.56.56 0 0 0 .56-.561V5.539a.562.562 0 0 0-.56-.561H19.14V2.15H24ZM12.812 8.533 9.204 11.49v5.15H8.08v-5.68l4.7-3.853 5.025 3.757v5.776h-4.277v-3.13h-2.201v-1.123h3.323v3.13h2.032v-4.09l-3.87-2.894Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 31.938h1.497V0H0v31.938ZM10.137 6.637h13.886V2.868H10.137v3.769ZM6.605 24.398h21.374V8.134H6.605v16.264ZM32 2.868V1.371H3.9v1.497h4.741v3.769H5.856a.749.749 0 0 0-.749.748v17.762c0 .413.336.748.749.748h22.872a.749.749 0 0 0 .749-.748V7.385a.749.749 0 0 0-.749-.748h-3.207V2.868H32Zm-14.916 8.509-4.811 3.945v6.865h-1.497v-7.574l6.265-5.136 6.701 5.009v7.701H18.04v-4.175h-2.934v-1.497h4.431v4.175h2.71v-5.455l-5.162-3.858Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.095 48H1.97V0H.095v48Zm14.861-37.838H36.2v-6.04H14.956v6.04Zm-5.31 26.694h32.5v-24.82h-32.5v24.82ZM48 4.123V2.248H5.77v1.875h7.312v6.039H8.709a.937.937 0 0 0-.938.937v26.694c0 .519.42.938.938.938h34.374c.517 0 .937-.42.937-.938V11.1a.937.937 0 0 0-.937-.937h-5.008v-6.04H48ZM25.579 16.86l-7.414 6.078v10.218H16.29V22.051l9.235-7.57 9.877 7.382v11.294h-8.196v-6.273h-4.409v-1.875h6.284v6.273h4.445v-8.479l-7.947-5.942Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 64h2.5V0H0v64Zm19.816-50.451h28.325V5.497H19.816v8.052Zm-7.08 35.592h43.332V16.049H12.736v33.092ZM63.874 5.497v-2.5H7.567v2.5h9.75v8.052h-5.83a1.25 1.25 0 0 0-1.25 1.25v35.592c0 .691.558 1.25 1.25 1.25h45.831c.69 0 1.25-.559 1.25-1.25V14.799c0-.691-.56-1.25-1.25-1.25h-6.677V5.497h13.233ZM33.98 22.482l-9.885 8.103V44.21h-2.5V29.401l12.313-10.094 13.169 9.844V44.21H36.149v-8.365h-5.88v-2.5h8.38v8.365h5.927V30.404l-10.597-7.922Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconRealEstate = function IconRealEstate(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Real Estate' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "RealEstate"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconRealEstate.sizes = [16, 24, 32, 48, 64];
IconRealEstate.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconRealEstate;
exports.default = _default;